import React from 'react';
import ServicesSection from "./ServiceSection";
import HeroSection from "./HeroSection";
import CalendarEvents from './CalendarEvents';
import MediaSlider from './MediaSlider';

function Home() {
    return (
        <>
            <HeroSection />
            <ServicesSection />
            <CalendarEvents />
            <MediaSlider />
        </>
    );
}

export default Home;
